module.exports = __webpack_public_path__ + "media/images/progress-75e2e14a.png";